// The shared policy contract. Each policy file exports a ReusePolicy object
// that the dispatcher (route-reuse.strategy.ts) picks based on `data.reuseRoute`.
import { ReusePolicy } from '../helpers';

/**
 * STRICT — full-URL string equality.
 *
 * Throws away the cache whenever the URL the user is going BACK to differs
 * even slightly from the URL we cached at — including a different ordering
 * of the same query params.
 *
 * Use this for: a route that identifies a distinct entity entirely through
 * its URL, where ANY difference (different param value, reordered params,
 * extra params) should mean "this is a new page, build it fresh".
 *
 * Opt in with `data: { reuseRoute: 'strict' }`. No route uses this today —
 * the default `reuseRoute: true` maps to preserveAlways, and sidebar clicks
 * already wipe the cache via clearFor(). Add 'strict' only if a specific
 * page actually needs URL-diff eviction beyond what the sidebar provides.
 */
export const strictPolicy: ReusePolicy = {
    // The string `data.reuseRoute: 'strict'` resolves to this policy.
    name: 'strict',

    // Direct string compare. fullUrl was the URL active when we cached the
    // route; targetUrl is the URL the router is about to navigate to.
    // If they don't match exactly → evict and let Angular build a fresh one.
    shouldEvict(cached, targetUrl) {
        return cached.fullUrl !== targetUrl;
    },
};
